import { useLocalSearchParams } from 'expo-router'

import { MessagesScreen } from '@/src/features/message/ui/screens/MessagesScreen'

export default () => {
  const searchParams = useLocalSearchParams()
  return <MessagesScreen searchParams={searchParams} />
}
